import React from "react";
import "./bookCard.scss";

export const BookCard = (props) => {
  const cleanUrl = (urlImage) => {
    const splitImage = urlImage.split(".");
    if (splitImage.length === 1) return urlImage;
    let cleanUrl = "";
    splitImage.forEach((word, index) => {
      if (index === splitImage.length - 1) {
        cleanUrl = cleanUrl.concat(".png");
      } else {
        cleanUrl = cleanUrl.concat(word);
      }
    });
    return cleanUrl;
  };
  const domainUrl =
    "https://www.ricardosalinas.com/images/libros/" + props?.books?.imagen;
  const localUrl =
    "/assets/img/homeSeisBooks/" + cleanUrl(props?.books?.imagen ?? "");

  return (
    <div className="book-card book-card-animate">
      <div className="book-card__metadata">
        <span className="book-card__metadata__title">
          {" "}
          {props.books.titulo}{" "}
        </span>
        <span className="book-card__metadata__author">{props.books.autor}</span>
      </div>
      <div
        className="book-card__front swiper-slide-book-img"
        onClick={() => props.onClick(props.index)}
      >
        <img
          className={`book-card__front__img${
            props.isActive ? "__activeImg" : ""
          }`}
          src={localUrl}
          alt="G-S-book"
        />
      </div>
    </div>
  );
};
